import script from "./VideoHeroBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoHeroBanner.vue?vue&type=script&setup=true&lang=ts"

import "./VideoHeroBanner.vue?vue&type=style&index=0&id=19218476&lang=scss"

const __exports__ = script;

export default __exports__